import { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { SimulationContext } from '../../context/SimulationContext';
import Header from '../../_components/TopBar/TopBar';
import ErrorModal from '../../_components/Modals/ErrorModal';

import icon_books from '../../assets/icons/books.svg';
import icon_cup from '../../assets/icons/cup.svg';
import logo_tf from '../../assets/icons/logo_tf_final.svg';
import close_icon from '../../assets/icons/close.svg';
import warning_icon from '../../assets/icons/warning-alert.svg';
import icon_grafico from '../../assets/icons/icon_grafico.svg';
import icon_bulb from '../../assets/icons/bulb.svg';
import icon_result from '../../assets/icons/high-five-hand.svg';

import './ResultScreen.css';
import { ResultGraph } from './ResultGraph';
import CloseResultModal from '../../_components/Modals/CloseResultModal';
import DisciplineProgressBox from './DisciplineProgressBox';
import OFAModal from '../../_components/Modals/OFAModal';
import ReducedResultGraph from './ReducedResultGraph';

import { useTranslation, Trans } from 'react-i18next';
import { prefixedT } from '../../i18n/utils';
import ResultSummary from './ResultSummary';

export default function ResultScreen() {
  let navigate = useNavigate();
  const { t } = useTranslation();
  const { simulationData } = useContext(SimulationContext);

  const [errorModalDetails, setErrorModalDetails] = useState({
    show: false,
    text: '',
    title: '',
  });
  const [step, setStep] = useState(0);
  const [showCloseResultModal, setShowCloseResultModal] = useState(false);
  const [showOFAModal, setShowOFAModal] = useState(false);

  const handleCloseErrorModal = () => {
    setErrorModalDetails({
      ...errorModalDetails,
      show: false,
    });
  };

  const handleOpenCloseResultModal = () => {
    setShowCloseResultModal(true);
  };

  const checkHasOFA = () => {
    return simulationData.stats.disciplines_score.find(
      (d) => d.is_ofa || d.is_reset
    );
  };

  const checkDisciplineResetAlert = (d) => {
    return (
      (d.reset_score && d.total_score < d.reset_score) ||
      (d.reset_correct_count && d.correct < d.reset_correct_count)
    );
  };

  const checkDisciplineOfaAlert = (d) => {
    return (
      !checkDisciplineResetAlert(d) &&
      ((d?.ofa_score && d?.total_score < d?.ofa_score) ||
        (d?.ofa_correct_count && d?.correct < d?.ofa_correct_count))
    );
  };

  const checkOfaAlert = () => {
    return simulationData.stats.disciplines_score.find(
      (d) => (d.is_ofa || d.is_reset) && !checkResetAlert(d) && checkOfaAlert(d)
    );
  };

  const checkResetAlert = () => {
    return simulationData.stats.disciplines_score.find(
      (d) => (d.is_ofa || d.is_reset) && checkDisciplineResetAlert(d)
    );
  };

  useEffect(() => {
    if (!simulationData) navigate('/', { replace: true });
  }, []);

  return (
    <div className='noselect simulation_screen'>
      <Header
        university_logo={simulationData?.admission_test}
        isBocconiDesign={simulationData?.is_bocconi_design}
      />

      {simulationData && simulationData.stats && (
        <div className='row mt-4 justify-content-center'>
          <div className='col p-3'>
            {/* Result cards stats passed or not */}
            {step === 0 && (
              <ResultSummary
                simulationData={simulationData}
                handleOpenCloseResultModal={handleOpenCloseResultModal}
                setStep={setStep}
              />
            )}

            {step === 1 && (
              <>
                {(simulationData.tag !== 'standard' ||
                  simulationData.type !== 'comparative') && (
                  <div className='d-flex justify-content-end'>
                    <img
                      src={close_icon}
                      onClick={handleOpenCloseResultModal}
                      className='pointer'
                    />
                  </div>
                )}
                <img src={icon_grafico} className='mx-auto section-icon' />
                <h1 className='text-center mt-2'>
                  {t(prefixedT('RESULT_SCREEN.PERFORMANCE_GRAPH'))}
                </h1>
                <div
                  className='mx-auto'
                  style={{
                    maxWidth: '400px',
                    minHeight:
                      simulationData?.stats?.disciplines_score?.length > 2
                        ? '400px'
                        : '300px',
                  }}
                >
                  {simulationData?.stats?.disciplines_score?.length > 2 ? (
                    <ResultGraph
                      data={simulationData.stats.disciplines_score}
                    />
                  ) : (
                    <ReducedResultGraph
                      data={simulationData.stats.disciplines_score}
                    />
                  )}
                </div>
                <div className='mt-5 mx-auto' style={{ maxWidth: '330px' }}>
                  {(simulationData?.type !== 'comparative' ||
                    simulationData?.show_review) && (
                    <button
                      id='closeModalButton'
                      className='w-100'
                      onClick={() => {
                        navigate('/revision', { replace: true });
                      }}
                    >
                      <img src={icon_bulb} className='me-2' />
                      {t(prefixedT('RESULT_SCREEN.REVIEW_QUESTIONS'))}
                    </button>
                  )}
                  <div className='d-flex navigation_buttons'>
                    <button
                      id='closeModalButton'
                      onClick={() => {
                        setStep(0);
                      }}
                      className='mt-2 white w-100'
                    >
                      {t(prefixedT('BUTTONS.BACK'))}
                    </button>
                    <button
                      id='closeModalButton'
                      disabled={
                        !checkHasOFA() && simulationData.type !== 'comparative'
                      }
                      onClick={() => {
                        setStep(checkHasOFA() ? 2 : 3);
                      }}
                      className='mt-2 ms-2 white w-100'
                    >
                      {t(prefixedT('BUTTONS.AHEAD'))}
                    </button>
                  </div>
                </div>
              </>
            )}

            {step === 2 && (
              <>
                <div className='d-flex justify-content-end'>
                  <img
                    src={close_icon}
                    onClick={handleOpenCloseResultModal}
                    className='pointer'
                  />
                </div>
                <img src={icon_books} className='mx-auto section-icon' />
                <h1 className='text-center mt-2'>
                  {t(prefixedT('RESULT_SCREEN.OFA_TITLE'))}
                </h1>
                <span
                  onClick={() => {
                    setShowOFAModal(true);
                  }}
                  className='text-center d-block modal_anchor pointer mt-2'
                >
                  {'Cosa sono gli OFA?'}
                </span>
                {checkHasOFA() && (checkOfaAlert() || checkResetAlert()) ? (
                  <div className='d-flex justify-content-center mt-4'>
                    {checkResetAlert() && (
                      <div style={{ maxWidth: '390px' }}>
                        <p className='text-center'>
                          {'Non hai raggiunto il punteggio minimo in:'}
                        </p>
                        {simulationData.stats.disciplines_score.map((d) => {
                          if (
                            (d.is_ofa || d.is_reset) &&
                            checkDisciplineResetAlert(d)
                          )
                            return <DisciplineProgressBox discipline={d} />;
                          else return '';
                        })}
                        <div
                          className='mt-5 p-3'
                          style={{
                            border: '4px solid #BC2A2A',
                            borderRadius: '16px',
                          }}
                        >
                          <img
                            src={warning_icon}
                            style={{ maxWidth: '24px' }}
                            className='d-block mx-auto'
                          />
                          <p className='mt-2 mb-0'>
                            {
                              'Ricorda: i moduli in cui non hai raggiunto il punteggio minimo non forniscono punti!'
                            }
                          </p>
                        </div>
                      </div>
                    )}
                    {checkOfaAlert() && (
                      <div style={{ maxWidth: '390px' }}>
                        <p>
                          {
                            'Bene, ma puoi migliorare! Al test ufficiale, avresti ricevuto OFA in:'
                          }
                        </p>
                        {simulationData.stats.disciplines_score.map((d) => {
                          if (
                            (d.is_ofa || d.is_reset) &&
                            checkDisciplineOfaAlert(d)
                          )
                            return <div></div>;
                          else return '';
                        })}
                      </div>
                    )}
                  </div>
                ) : (
                  <div className='mx-auto' style={{ maxWidth: '350px' }}>
                    <img className='d-block mx-auto mt-10' src={icon_result} />
                    <p className='text-center mt-2'>
                      {'Grande! Con questo punteggio, non avresti ricevuto '}
                      <img src={icon_books} />
                      <strong className='text-tf'>{' OFA '}</strong>
                      {'al test ufficiale.'}
                    </p>
                  </div>
                )}
                <div className='mt-5 mx-auto' style={{ maxWidth: '330px' }}>
                  {(simulationData?.type !== 'comparative' ||
                    simulationData?.show_review) && (
                    <button
                      id='closeModalButton'
                      className='w-100'
                      onClick={() => {
                        navigate('/revision', { replace: true });
                      }}
                    >
                      <img src={icon_bulb} className='me-2' />
                      {t(prefixedT('RESULT_SCREEN.REVIEW_QUESTIONS'))}
                    </button>
                  )}
                  <div className='d-flex navigation_buttons'>
                    <button
                      id='closeModalButton'
                      onClick={() => {
                        setStep(1);
                      }}
                      className='mt-2 white w-100'
                    >
                      {t(prefixedT('BUTTONS.BACK'))}
                    </button>
                    <button
                      id='closeModalButton'
                      disabled={simulationData.type !== 'comparative'}
                      onClick={() => {
                        setStep(3);
                      }}
                      className='mt-2 ms-2 white w-100'
                    >
                      {t(prefixedT('BUTTONS.AHEAD'))}
                    </button>
                  </div>
                </div>
                <OFAModal
                  show={showOFAModal}
                  handleClose={() => {
                    setShowOFAModal(false);
                  }}
                />
              </>
            )}

            {step === 3 && (
              <>
                <div className='d-flex justify-content-end'>
                  <img
                    src={close_icon}
                    onClick={handleOpenCloseResultModal}
                    className='pointer'
                  />
                </div>
                <img src={icon_cup} className='mx-auto section-icon' />
                <h1 className='text-center mt-2'>
                  {t(prefixedT('RESULT_SCREEN.SCOREBOARD'))}
                </h1>
                <div className='mx-auto' style={{ maxWidth: '350px' }}>
                  <img className='d-block mx-auto mt-10' src={logo_tf} />
                  <p className='text-center mt-2'>
                    {t(prefixedT('RESULT_SCREEN.SCOREBOARD_TEXT'))}
                  </p>
                </div>
                <div className='mt-10 mx-auto' style={{ maxWidth: '330px' }}>
                  <button
                    id='closeModalButton'
                    onClick={() => {
                      setStep(1);
                    }}
                    className='mt-2 white w-100'
                  >
                    {t(prefixedT('BUTTONS.BACK'))}
                  </button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      <ErrorModal
        show={errorModalDetails.show}
        title={errorModalDetails.title}
        text={errorModalDetails.text}
        handleClose={handleCloseErrorModal}
      />
      <CloseResultModal
        show={showCloseResultModal}
        handleClose={() => {
          setShowCloseResultModal(false);
        }}
        isBocconiDesign={simulationData?.is_bocconi_design}
      />
    </div>
  );
}
